<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
      let datas = [
      {
        name: "已整改",
        value: 60,
      },
      {
        name: "未整改",
        value: 40,
      },
    ];

    this.state.chart.setOption({
        color: [
          "rgba(252, 119, 50, 1)",
          "rgba(0, 255, 186, 1)",
          ],
        title: {
          text: '整改率',
          left: 'center',
          top: 'center',
          textStyle: {
              color: "rgba(255, 255, 255, 1)",
              fontWeight: 'bold',
              fontSize: "16",
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "60%"],
            center: ["50%", "50%"],
            roseType: "radius",
            label: {
              formatter: function (params) {
                  if (params.name !== '') {
                    return `{a|${params.name}：}{b|${params.percent}%}`;
                  } else {
                    return '';
                  }
              },
              rich: {
                  a: {
                    padding: [0, 0, 20, -20],
                    color: '#fff'
                  },
                  b: {
                    padding: [0, -20, 20, 0],
                    color: '#fff'
                  },
              }
            },
            labelLine: {
              length: 10,
              length2: 20,
            },
            data: datas,
          },
        ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
